import React, { useState, useEffect } from 'react';
import moment from 'moment'
import Header from '../../../components/Header';
import Footer from '../../../components/Footer';
import { Row, Col, message, Spin, Popconfirm, Switch } from 'antd';
import { Table, Button, Form, Select } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { MinusOutlined, PlusOutlined, LockFilled, UnlockFilled } from '@ant-design/icons';
import 'antd/dist/antd.css';
import api from '../../../services/api';
import * as ModalStatusAction from '../../../redux/actions/modalStatus'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ModalPreCadastro from '../../../components/ModalPreCadastro';
import opcoesDeFiltros from './opcoesDeFiltros';
import { useHistory } from 'react-router-dom';
import { dadosCadastraisService } from '../../../services/Dados-Cadastrais-Service/dados-cadastrais-service';
import './styles.css'

interface ConsultaPops {
    setPreCadastroModal: any,
    modalStatus: any
}

const Consulta: React.FC<ConsultaPops> = (props) => {

    const history = useHistory();
    const [form] = Form.useForm();
    const [escolaridades, setEscolaridades] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [filtrosSelecionados, setFiltrosSelecionados] = useState<any[]>([]);
    const [data, setData] = useState<any[]>([]);
    const [filtros, setFiltros] = useState<any[]>([]);
    const [visibleInativar, setVisibleInativar] = useState<boolean>(false);
    const [ehGestor, setEhGestor] = useState<boolean>(false);
    const [ehRecepcao, setEhRecepcao] = useState(false);

    useEffect(() => {
        setFiltros(opcoesDeFiltros(renderBotaoDeleteFiltro, []));
        getEscolaridade();
        pesquisar(true);
        validarEhGestor();
        validarEhRecepcao()
    }, [])

    useEffect(() => {
        validarEhRecepcao();
    }, []);

    useEffect(() => {
        setFiltrosSelecionados([filtros[0], filtros[1]]);
    }, [filtros])

    useEffect(() => {
        if (props.modalStatus[0].visiblePreCadastro == false) {
            pesquisar();
        }
    }, [props.modalStatus[0].visiblePreCadastro])

    const inativarCadastro = (id: any) => {
        setLoading(true);
        dadosCadastraisService.ativarInativar(id, false).then(() => {
            message.success('Cadastro inativado com sucesso');
        })
            .finally(() => {
                setLoading(false);
                pesquisar();
            })
            .catch((err) => {
                message.error(err?.response?.data?.message ? err?.response?.data?.message : 'Falha na requisição', 10)
            })

    }

    const ativarCadastro = (id: any) => {
        setLoading(true);
        dadosCadastraisService.ativarInativar(id, true).then(() => {
            message.success('Cadastro ativado com sucesso');
        })
            .finally(() => {
                setLoading(false);
                pesquisar();
            })
            .catch((err) => {
                message.error(err?.response?.data?.message ? err?.response?.data?.message : 'Falha na requisição', 10)
            })
    }

    const getEscolaridade = async () => {
        setLoading(true);
        await api.get('Escolaridade')
            .then((response) => {
                setFiltros(opcoesDeFiltros(renderBotaoDeleteFiltro, response.data));
                setEscolaridades(response.data);
                setLoading(false);
            })
            .catch(() => {
                message.error("Falha na requisição das escolaridades");
                setLoading(false);
            })
    }

    const columns = [
        { title: 'Nome', dataIndex: 'nome', width: 200, fixed: 'left' as 'left' },
        {
            title: 'Data de Nascimento', dataIndex: 'dataNascimento',
            render: ((data: string) => data ? moment(data).format('DD/MM/YYYY') : ''), width: 80,
        },
        { title: 'País', dataIndex: 'pais', width: 140, },
        {
            title: 'Ativo', dataIndex: 'ativo', width: 80,
            render: (text: any, record: any) => (<p>{record.ativo ? 'Sim' : 'Não'}</p>)
        },
        { title: 'Idioma', dataIndex: 'idioma', width: 150, },
        { title: 'Nome Social', dataIndex: 'nomeSocial', width: 200, },
        { title: 'Cidade natal', dataIndex: 'municipioNascimento', width: 150, },
        { title: 'Estado', dataIndex: 'estadoProvincia', width: 200, },
        {
            title: 'Chefe Familiar', dataIndex: 'chefeFamilia', width: 60,
            render: (text: any, record: any) => (<p>{record.chefeFamilia ? 'Sim' : 'Não'}</p>)
        },
        // {
        //     title: 'Data da matrícula', dataIndex: 'dataMatricula', width: 180,
        //     render: ((data: string) => data ? moment(data).format('DD/MM/YYYY') : '')
        // },
        {
            title: 'Reside No Brasil', dataIndex: 'resideNoBrasil', width: 80,
            render: (text: any, record: any) => (<p>{record.resideNoBrasil ? 'Sim' : 'Não'}</p>)
        },
        { title: 'Sexo', dataIndex: 'sexo', width: 100, },
        { title: 'Instituicao', dataIndex: 'instituicao', width: 200, },
        { title: 'Estado Civil', dataIndex: 'estadoCivil', width: 200, },
        { title: 'Nome do Pai', dataIndex: 'nomePai', width: 200, },
        { title: 'Nome da Mãe', dataIndex: 'nomeMae', width: 200, },
        {
            title: 'Escolaridade', dataIndex: 'descricao', width: 200,
            render: (text: any, record: any) => (<p>{record.escolaridade?.descricao}</p>),
        },
        {
            title: 'Ações', dataIndex: '', key: 'x', width: visibleInativar ? 160 : 110,

            render: (text: any, record: any) => (
                <>
                    <div className="divButtonTable">
                        <Button type="primary" className='buttonEditar' size={'middle'} onClick={() => history.push(`/dados-cadastrais/cadastro/${record.dadosCadastraisID}/tabela/1`)}>
                            {ehRecepcao ? 'Visualizar' : 'Editar'}
                        </Button>
                        <Button type="primary" size={'middle'} onClick={() => {
                            let menus: any[] = JSON.parse(sessionStorage.getItem('modulos') || '[]');
                            if (menus.length > 0) {
                                let menu: any = menus.find(m => m.nome.trim().toLowerCase().replace(' ', '') === 'familia');
                                if (menu != null) {
                                    history.push(`/familia/${record.dadosCadastraisID}`)
                                }
                                else {
                                    history.replace('/error', { mensagem: "Usuário não possui permissão ao módulo." })
                                }
                            }
                        }}>
                            Família </Button>
                        {ehGestor ?
                            record.ativo ?
                                <Popconfirm title={
                                    <div> <strong> Atenção </strong>
                                        <br />
                                        Esta ação remove o cadastro da lista de pesquisa dos migrantes, <br /> você tem certeza que deseja inativar esse cadastro?
                                    </div>}
                                    onConfirm={() => { inativarCadastro(record.dadosCadastraisID) }} okText="Sim" cancelText="Não">
                                    <Button size={'middle'} danger hidden={!visibleInativar}>  Inativar </Button>
                                </Popconfirm>
                                :
                                <Popconfirm title={
                                    <div> <strong> Atenção </strong>
                                        <br />
                                        Você tem certeza que deseja Ativar esse cadastro?
                                    </div>}
                                    onConfirm={() => { ativarCadastro(record.dadosCadastraisID) }} okText="Sim" cancelText="Não">
                                    <Button size={'middle'} className="buttonAtivar" hidden={!visibleInativar}>  Ativar </Button>
                                </Popconfirm>
                            : null
                        }

                    </div>
                </>
            ),
            fixed: 'right' as 'right',
        },
    ];

    const adicionarFiltro = () => {
        if (form.getFieldValue('filtroSelecionado') != null && filtrosSelecionados.filter(item => { return item.name == form.getFieldValue('filtroSelecionado') }).length === 0) {

            let item, key: number;;

            item = filtros.filter(item => { return item.name == form.getFieldValue('filtroSelecionado') })[0];
            setFiltrosSelecionados([...filtrosSelecionados, item]);
            key = item.key + 1 >= filtros.length ? 0 : item.key + 1;

            form.setFieldsValue({ filtroSelecionado: filtros.filter(item => { return item.key === key })[0].name })
        }

    }

    const removerFiltroSelecionado = (name: string) => {
        form.resetFields([name])
        setFiltrosSelecionados(filtro => filtro.filter(item => { return item.name !== name }));
    }

    function renderBotaoDeleteFiltro(name: string) {
        return <Button
            type="dashed"
            onClick={(() => (removerFiltroSelecionado(name)))}
            icon={<MinusOutlined />} danger>
        </Button>
    }

    function pesquisar(primeiroCarregamento: boolean = false) {
        let filtros = form.getFieldsValue();
        let newParams = {
            'nome': filtros.nome ? filtros.nome : undefined,
            'dataNascimento': filtros.dataNascimento ? moment(filtros.dataNascimento, "DD/MM/YYYY").format("YYYY-MM-DD") : undefined,
            'pais': filtros.pais ? filtros.pais : undefined,
            'nomePai': filtros.nomePai ? filtros.nomePai : undefined,
            'nomeMae': filtros.nomeMae ? filtros.nomeMae : undefined,
            'idioma': filtros.idioma ? filtros.idioma : undefined,
            'sexo': filtros.sexo ? filtros.sexo : undefined,
            'estadoCivil': filtros.estadoCivil ? filtros.estadoCivil : undefined,
            'municipioNascimento': filtros.municipioNascimento ? filtros.municipioNascimento : undefined,
            'estadoProvincia': filtros.estadoProvincia ? filtros.estadoProvincia : undefined,
            'escolaridadeID': filtros.escolaridadeID ? filtros.escolaridadeID : undefined,
            'nomeSocial': filtros.nomeSocial ? filtros.nomeSocial : undefined,
            'estudando': filtros.estudando ? filtros.estudando : undefined,
            'instituicao': filtros.instituicao ? filtros.instituicao : undefined,
            // 'dataMatricula': filtros.dataMatricula ? moment(filtros.dataMatricula,"DD/MM/YYYY").format("YYYY-MM-DD") : undefined,
            'chefeFamilia': filtros.chefeFamilia ? filtros.chefeFamilia : undefined,
            'resideNoBrasil': filtros.resideNoBrasil ? filtros.resideNoBrasil : undefined,
            'ativo': primeiroCarregamento ? true : filtros.ativo ? filtros.ativo : undefined,
        }
        setLoading(true)
        api.get(`DadosCadastrais/getcomfiltros`, { params: newParams }).then(response => {
            setData(response.data);
        })
            .finally(() => setLoading(false))
    }

    const habilitarInativarCadastro = () => {
        setVisibleInativar(!visibleInativar);
    }

    const validarEhGestor = () => {
        var grupoLogado = parseInt(sessionStorage.getItem('grupoID') || "")
        if (grupoLogado == 1330 || grupoLogado == 1334 || grupoLogado == 1336)
            setEhGestor(true)
        else
            setEhGestor(false)
    }

    const validarEhRecepcao = () => {
        var modulos = JSON.parse(sessionStorage.getItem('modulos') || '[]');
        var novoEhRecepcao = modulos.some((modulo: any) => modulo.permissao?.consultar && !modulo.permissao?.editar && modulo.navegarURL?.includes("dados-cadastrais"));        
        if (novoEhRecepcao !== ehRecepcao) {
            setEhRecepcao(novoEhRecepcao);
        }
    };

    return (
        <>
            <Header />
            <br />
            <div className="container">
                <fieldset className="fieldset-consulta">
                    <Row align="middle" justify="center"  >
                        <Col span={24} >
                            <Form
                                labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}
                                name="consulta"
                                form={form}
                            >
                                <div className="row">
                                    {filtrosSelecionados.map((filtro, index) => { return filtro?.item })}
                                    <div className="col-md-4" >
                                        <Row>
                                            <Col span={20}>
                                                <Form.Item label="Filtros" name="filtroSelecionado">
                                                    <Select placeholder="Selecione" style={{ width: '100%' }}>
                                                        {filtros.map((item, index) => {
                                                            return <Select.Option key={index} value={item.name}>{item.label}</Select.Option>
                                                        })}
                                                    </Select>
                                                </Form.Item>
                                            </Col>
                                            <Col span={4} >
                                                <Form.Item label="&nbsp;">
                                                    <Button
                                                        type="dashed"
                                                        onClick={() => adicionarFiltro()}
                                                        icon={<PlusOutlined />}>
                                                    </Button>
                                                </Form.Item>
                                            </Col>

                                        </Row>
                                    </div>
                                </div>
                                <div className="row">
                                    <div>
                                        <Form.Item className="buttons">
                                            <Row className='rowButtons'>
                                                <Col span={6}>
                                                    <Button style={{ marginRight: 8 }} loading={loading} onClick={(() => pesquisar())} htmlType="submit" type="primary" icon={<SearchOutlined />}> Pesquisar </Button>

                                                </Col>
                                                <Col span={6}>
                                                    <Button className='buttonPreCadastro' style={{ marginRight: 8 }} type="primary" htmlType="button" onClick={() => { props.setPreCadastroModal(true) }}>
                                                        Pré-Cadastro
                                                    </Button>
                                                </Col>

                                                <Col span={6}>
                                                    <Button style={{ marginRight: 8 }} onClick={() => { form.resetFields() }} type="primary" danger htmlType="button">
                                                        Limpar Filtros
                                                    </Button>
                                                </Col>
                                                <Col span={6}>
                                                    {ehGestor ?
                                                        <div className='switchInativar'><Switch id='switchInativar' checkedChildren={<><LockFilled /></>} unCheckedChildren={<><UnlockFilled /></>} style={{ marginRight: 8 }} onChange={() => { habilitarInativarCadastro() }} /><b ><label htmlFor="switchInativar" className={visibleInativar ? 'spanInativarOn' : 'spanInativarOff'}>Inativar Cadastros</label></b></div>
                                                        : null
                                                    }
                                                </Col>
                                            </Row>
                                        </Form.Item>

                                    </div>
                                </div>
                            </Form>
                        </Col>
                    </Row>
                </fieldset>
                <br />
                <Row align="middle" justify="center" >
                    <Col span={24}>
                        <Table bordered
                            className="ant-table-var-local"
                            columns={columns}
                            dataSource={data}
                            scroll={{ x: 5000 }}
                            rowKey={"dadosCadastraisID"}
                            pagination={{ pageSize: 15 }}
                            loading={loading}
                            sticky />

                    </Col>
                </Row>
            </div>
            <ModalPreCadastro></ModalPreCadastro>
            <Footer />
        </>
    );
}

const mapStateToProps = (state: any) => ({
    modalStatus: state.modalStatus,
})

const mapDispatcToProps = (dispatch: any) => bindActionCreators(ModalStatusAction, dispatch)

export default connect(mapStateToProps, mapDispatcToProps)(Consulta);